export default __webpack_public_path__ + "static/media/NMC_12.13c17f82.svg";